import Vue from 'vue';
import Modal from './offerModal.vue'

let DialogConstructor = Vue.extend(Modal) // 构造函数
let instance // 实例对象

const the_Modal = (options = {}) => {
  instance = new DialogConstructor({
    data: options
  })
  
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.dialogVisible = true
  instance.dom = instance.vm.$el
  return instance.vm
}

export default the_Modal


// WEBPACK FOOTER //
// ./src/components/OfferModal/index.js